export default __webpack_public_path__ + "static/media/BT.72831100.svg";